import React from 'react';
import { SectionLabel } from './SectionLabel';
import { MISSION, VISION } from '../data/site';
export function MissionVision() {
  return <section className="border-b border-ink-100 bg-ink-950" data-id="element-92" data-mp="5ldlqagdzmpx">
      <div className="mx-auto max-w-container px-6 py-20 lg:px-10 lg:py-28" data-id="element-93" data-mp="jdjrd2lwybb4">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-0" data-id="element-94" data-mp="fbyjjvo8kn7s">
          <div className="lg:pr-16" data-id="element-95" data-mp="fci13b9z59la">
            <SectionLabel tone="dark" data-id="element-96" data-mp="3nr8g6o9cx086">Our mission</SectionLabel>
            <p className="mt-8 text-2xl font-medium leading-snug tracking-tight text-white lg:text-[2rem] lg:leading-[1.25]" data-id="element-97" data-mp="3nrry44z0bom7">
              “{MISSION}”
            </p>
          </div>
          <div className="border-t border-ink-800 pt-14 lg:border-l lg:border-t-0 lg:pl-16 lg:pt-0" data-id="element-98" data-mp="odie7ax8y2i">
            <SectionLabel tone="dark" data-id="element-99" data-mp="3rrk2s6la5ama">Our vision</SectionLabel>
            <p className="mt-8 text-xl leading-relaxed text-ink-300 lg:text-2xl lg:leading-[1.45]" data-id="element-100" data-mp="1c167198f16ec">
              {VISION}
            </p>
          </div>
        </div>
      </div>
    </section>;
}